import { SpinningLoader } from "risa-oasis-ui_v2";
import CriteriaEvaluationStateGraphic from "./CriteriaEvaluationStateGraphic";

/**
 * Full-panel progress state shown while criteria analysis is being queued.
 *
 * @returns Centered criteria-evaluation loading screen
 */
export function CriteriaEvaluationLoading() {
  return (
    <div
      className="flex h-full min-h-0 items-center justify-center bg-white"
      role="status"
      aria-live="polite"
    >
      <div className="flex flex-col items-center text-center">
        <CriteriaEvaluationStateGraphic className="criteria-evaluation-loading__spinner">
          <SpinningLoader />
        </CriteriaEvaluationStateGraphic>
        <h2 className="mb-2 text-base font-bold text-primaryGray-2">
          Evaluating Criteria
        </h2>
        <p className="m-0 max-w-sm text-base leading-7 text-primaryGray-3">
          Evaluating patient criteria per protocol;
          <br />
          please wait a few minutes.
        </p>
      </div>
    </div>
  );
}

export default CriteriaEvaluationLoading;
